import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import BasicDetails from "./basicDetails";
import GeneralSettings from "./generalSettings";
import FeedbackSettings from "./feedbackSettings";
import BugSettings from "./bugSettings";
import FeatureRequsetSettings from "./featureRequestSettings";
import WidgetAppearance from "./widgetAppearance";
import EmailSettings from "./emailSettings";
import APISettings from "./apiSettings";
import TrackingSysSettings from "./trackingSysSettings";
import { enableJira, enableZendesk } from "../../../utils/config";
import { appLogger } from "../../../utils";
import QRsettings from "./QRsettings";
import {
  FEEDBACK_TYPE_BUGS,
  FEEDBACK_TYPE_FEATURE_REQ,
  FEEDBACK_TYPE_FEEDBACK,
  FEEDBACK_TYPE_AI_SUPPORT,
  PLATFORM_TYPE_TV,
} from "../../../model";

import ProductDetailsHeader from "./ProductDetailsHeader";
import {
  enableFeedback,
  enableBugReport,
  enableFeatureRequest,
} from "../../../utils/config";

function ProductsForm(props: any) {
  appLogger.info({
    infoObj: {
      method: "ProductsForm",
      component: "add-product",
      fileName: "productsForm.tsx",
      props: props,
    },
  });
  const {
    setWidgetActionValue,
    productParams,
    setProductParams,
    errMsg,
    setErrMsg,
    setScroll,
    setpreviewScroll,
    sethandleClick,
    saveProduct,
    basicSettingsMandatoryCheck,
    generalSettingsMandatoryCheck,
    feedbackSettingsMandatoryCheck,
    bugSettingsMandatoryCheck,
    featureSettingsMandatoryCheck,
    widgetSettingsMandatoryCheck,
    enabledFeatures,
  } = props;
  let userEnabledFeatures: any = localStorage.getItem("userenabledFeatures");
  if (userEnabledFeatures) {
    userEnabledFeatures = JSON.parse(userEnabledFeatures);
  }
  const [widgetShow, setWidgetShowValues] = useState<any>();
  const setWidgetShow = (e: any) => {
    setWidgetShowValues(e);
  };

  useEffect(() => {
    if (widgetShow) {
      setWidgetShowValues(widgetShow);
    }
  }, [widgetShow?.widgetInfo.buttonColor]);

  useEffect(() => {
    setWidgetActionValue(widgetShow);
  }, [widgetShow]);
  const Emailaccref = useRef<any>(null);

  const setFeaReqAccordianScroll = () => {
    // if (e == "feature") {
    Emailaccref?.current?.scrollIntoView({ behavior: "smooth" });
    //
    // }
  };
  const setGeneralScrollRef = useRef<any>(null);

  const setGeneralScroll = () => {
    setGeneralScrollRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Box className="accordion-wrap">
      <ProductDetailsHeader product={productParams?.products?.[0]} />
      <GeneralSettings
        productParams={productParams}
        setScroll={setScroll}
        setProductParams={setProductParams}
        errMsg={errMsg}
        setErrMsg={setErrMsg}
        setpreviewScroll={setpreviewScroll}
        sethandleClick={sethandleClick}
        setGeneralScroll={setGeneralScroll}
        generalSettingsMandatoryCheck={generalSettingsMandatoryCheck}
      />
      {enableFeedback &&
      userEnabledFeatures?.enableFeedback &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
        FEEDBACK_TYPE_FEEDBACK
      ) ? (
        <FeedbackSettings
          productParams={productParams}
          setScroll={setScroll}
          setProductParams={setProductParams}
          errMsg={errMsg}
          setErrMsg={setErrMsg}
          setpreviewScroll={setpreviewScroll}
          sethandleClick={sethandleClick}
          feedbackSettingsMandatoryCheck={feedbackSettingsMandatoryCheck}
        />
      ) : (
        ""
      )}
      {enableBugReport &&
      userEnabledFeatures?.enableBugReport &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
        FEEDBACK_TYPE_BUGS
      ) ? (
        <>
          <BugSettings
            productParams={productParams}
            setScroll={setScroll}
            setProductParams={setProductParams}
            errMsg={errMsg}
            setErrMsg={setErrMsg}
            setpreviewScroll={setpreviewScroll}
            sethandleClick={sethandleClick}
            bugSettingsMandatoryCheck={bugSettingsMandatoryCheck}
          />
        </>
      ) : (
        ""
      )}
      {enableFeatureRequest &&
      userEnabledFeatures?.enableFeatureRequest &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
        FEEDBACK_TYPE_FEATURE_REQ
      ) ? (
        <FeatureRequsetSettings
          productParams={productParams}
          setScroll={setScroll}
          setProductParams={setProductParams}
          errMsg={errMsg}
          setErrMsg={setErrMsg}
          setpreviewScroll={setpreviewScroll}
          setFeaReqAccordianScroll={setFeaReqAccordianScroll}
          sethandleClick={sethandleClick}
          featureSettingsMandatoryCheck={featureSettingsMandatoryCheck}
        />
      ) : (
        ""
      )}

      <QRsettings
        productParams={productParams}
        setpreviewScroll={setpreviewScroll}
        setScroll={setScroll}
        setProductParams={setProductParams}
        sethandleClick={sethandleClick}
      />

      <WidgetAppearance
        setWidgetVal={setWidgetShow}
        productParams={productParams}
        setScroll={setScroll}
        setProductParams={setProductParams}
        setpreviewScroll={setpreviewScroll}
        enableJira={enableJira}
        sethandleClick={sethandleClick}
        saveProduct={saveProduct}
        widgetSettingsMandatoryCheck={widgetSettingsMandatoryCheck}
      />

      {productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].id &&
      productParams.products[0].version &&
      !productParams.products[0].cloneNewVersion ? (
        <APISettings
          productParams={productParams}
          setScroll={setScroll}
          setProductParams={setProductParams}
          sethandleClick={sethandleClick}
        />
      ) : (
        ""
      )}
    </Box>
  );
}

export default ProductsForm;
